import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import Seo from "../components/Seo";
import { fetchServicesPage } from "../lib/api";

export default function Services() {
    const [page, setPage] = useState(null);

    useEffect(() => {
        fetchServicesPage().then(setPage).catch(() => {});
    }, []);

    if (!page) {
        return (
            <main data-testid="page-services" className="pt-40 px-6 md:px-12 lg:px-24 pb-32">
                <p className="asc-overline">Loading…</p>
            </main>
        );
    }

    const items = page.items || [];

    return (
        <main data-testid="page-services" className="pt-32 md:pt-40">
            <Seo
                path="/services"
                title="Services — Hospitality Interior Architecture, FF&E and Concept"
                description={page.intro || ""}
            />
            <section className="px-6 md:px-12 lg:px-24 pb-20">
                <Reveal>
                    <p className="asc-overline">{page.eyebrow || "Services"}</p>
                </Reveal>
                <Reveal delay={100}>
                    <h1 className="serif text-5xl sm:text-6xl lg:text-7xl mt-6 leading-[1.02] tracking-tight font-light max-w-5xl">
                        {page.title_line_1}{" "}
                        {page.title_italic && (
                            <span className="italic">{page.title_italic}</span>
                        )}
                        {page.title_line_2 && (
                            <>
                                <br />
                                {page.title_line_2}
                            </>
                        )}
                    </h1>
                </Reveal>
                <Reveal delay={180}>
                    <p className="mt-10 max-w-2xl text-lg lg:text-xl text-[#5C5855] leading-relaxed">
                        {page.intro}
                    </p>
                </Reveal>
            </section>

            <section className="px-6 md:px-12 lg:px-24 pb-24">
                <div
                    data-testid="services-detail"
                    className="border-t border-[#E5E1DB]"
                >
                    {items.map((s, i) => (
                        <Reveal key={`${s.number}-${i}`} delay={i * 60}>
                            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 py-10 lg:py-14 border-b border-[#E5E1DB]">
                                <div className="lg:col-span-1 asc-overline text-[#8C7A6B]">
                                    {s.number}
                                </div>
                                <div className="lg:col-span-4">
                                    <h2 className="serif text-3xl lg:text-4xl tracking-tight font-light">
                                        {s.title}
                                    </h2>
                                </div>
                                <div className="lg:col-span-7 text-[#1A1A1A] leading-relaxed text-base lg:text-lg font-light">
                                    {s.description}
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </section>

            {page.cta_label && (
                <section className="px-6 md:px-12 lg:px-24 py-24 md:py-32 bg-[#1A1A1A] text-[#F9F8F6]">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
                        <div className="lg:col-span-7">
                            {page.cta_eyebrow && (
                                <p className="asc-overline text-[#8C7A6B]">{page.cta_eyebrow}</p>
                            )}
                            <h2 className="serif text-4xl lg:text-5xl mt-6 leading-[1.1] tracking-tight font-light">
                                {page.cta_title_line_1}
                                {page.cta_title_italic && (
                                    <>
                                        <br />
                                        <span className="italic">{page.cta_title_italic}</span>{" "}
                                    </>
                                )}
                                {page.cta_title_line_2}
                            </h2>
                        </div>
                        <div className="lg:col-span-5 lg:text-right">
                            <Link
                                to={page.cta_link || "/contact"}
                                data-testid="services-cta"
                                className="inline-flex items-center px-8 py-4 bg-[#F9F8F6] text-[#1A1A1A] text-[11px] uppercase tracking-[0.24em] hover:bg-[#E5E1DB] transition-colors"
                            >
                                {page.cta_label}
                            </Link>
                        </div>
                    </div>
                </section>
            )}
        </main>
    );
}
